import React from "react"
import ChipSelect from "../common/ChipSelect"
import strings from "../../localization/strings"
import _ from "lodash"
import AccountStore from "../../stores/AccountStore"

interface IProps {
    title: string
    selectedPayTypeIds: string[]
    readonly?: boolean
    error?: string
    disAllowEmpty?: boolean
    handleChange(selectedPayTypeIds: string[]): void
}

const PayTypeSelectChip: React.SFC<IProps> = (props: IProps) => {
    const payTypes = AccountStore.getCurrentAccount().PayTypes.map(i => { return { Id: i.Id as string, Name: i.Name } })
    const selectedPayTypeItems = props.selectedPayTypeIds.map(i => payTypes.find(e => e.Id === i))
    return (
        <ChipSelect
            readonly={props.readonly}
            title={props.title}
            titleStyle={{ color: "rgba(0, 0, 0, 0.3)", fontSize: 13 }}
            allData={payTypes}
            linkedData={selectedPayTypeItems}
            chipStyle={{ marginTop: 10, marginRight: 5, height: 35 }}
            addButtonStyle={{ height: 35, marginTop: 2, display: "inline-block" }}
            labelTextForSelect={strings.Select_Pay_Type}
            disAllowEmpty={props.disAllowEmpty}
            handleAddOne={item => {
                const selectedPayTypeIds = _.cloneDeep(props.selectedPayTypeIds)
                selectedPayTypeIds.push(item.Id)
                props.handleChange(selectedPayTypeIds)
            }}
            handleDeleteOne={item => {
                let selectedPayTypeIds = _.cloneDeep(props.selectedPayTypeIds)
                selectedPayTypeIds = selectedPayTypeIds.filter(i => i !== item.Id)
                props.handleChange(selectedPayTypeIds)
            }}
            errorText={props.error}
        />
    )
}

export default PayTypeSelectChip